<form class="mce-form-section">


    <div class="mce-form-field-group">

        @if (form().case().value() == 'dc') {
        <div>
            <mat-form-field class="w-full">
                <mat-label>d.c. earthing</mat-label>
                <mat-select [formField]="form().dcCase">
                    @for (option of dcCaseOpitons(); track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        }


        @if (form().case().value() == 'aclv') {
        <div>
            <mat-form-field class="w-full">
                <mat-label>a.c. low voltage earthing</mat-label>
                <mat-select [formField]="form().aclvCase">
                    @for (option of aclvCaseOptions(); track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        }

        @if (form().case().value() == 'achv') {
        <div>
            <mat-form-field class="w-full">
                <mat-label>a.c. high voltage earthing</mat-label>
                <mat-select [formField]="form().achvCase">
                    @for (option of achvCaseOptions(); track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        }

        @if(!isIsolatedEarth()) {   

        <div>
            <mat-form-field>
                <mat-label>soil resistivity</mat-label>
                <input matInput type="number" placeholder="soil resistivity"
                       [formField]="form().soilResistivity" />
                <span matSuffix>Ω.m</span>
                @for (error of form().soilResistivity().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>
        }

    </div>

</form>
